// Методы для помощи в подготовке данных для слотов таблиц
export const tablePrepareData = {
  methods: {
    byNameObjectGlueOutput(elements, glue = ', ') {
      let listOfNames = [];
      elements.forEach((element) => {
        listOfNames.push(element.name);
      });

      return listOfNames.length > 0 ? listOfNames.join(glue) : "—";
    },
    arrayGlueOutput(elements, glue = ', ') {
      return elements.length > 0 ? elements.join(glue) : "—";
    },
    referencePropertyById(property_id, prop = 'text') {
      if (this.$store.getters.REFERENCE_PROPERTIES[property_id]) {
        return this.$store.getters.REFERENCE_PROPERTIES[property_id][prop];
      }

      return '';
    },
    referencePropertyArrayGlueOutput(elements, glue = ', ') {
      let elementsNames = [];

      elements.forEach((elem) => {
        elementsNames.push(this.referencePropertyById(elem));
      });

      return elementsNames.length > 0 ? elementsNames.join(glue) : "—";
    },
    transportItemById(item_id, prop = 'name') {
      if (this.$store.getters.ALL_TRANSPORT_LIST[item_id]) {
        return this.$store.getters.ALL_TRANSPORT_LIST[item_id][prop];
      }

      return '';
    },
    transportArrayGlueOutput(elements, glue = ', ') {
      let elementsNames = [];

      elements.forEach((elem) => {
        elementsNames.push(this.transportItemById(elem));
      });

      return elementsNames.length > 0 ? elementsNames.join(glue) : "—";
    },
    transportArrayGroupedByType(elements) {
      let elementsItems = {};

      elements.forEach((elem) => {
        elem = this.$store.getters.ALL_TRANSPORT_LIST[elem];

        if (!elementsItems[elem.category.name]) {
          elementsItems[elem.category.name] = [];
        }

        elementsItems[elem.category.name].push(elem.id);
      });

      return elementsItems;
    },
    prepareEmployees(company_employees) {
      let tempCompanyEmployee = [];

      if (this.items.request &&
        this.items.request.need_employees_with_segments &&
        this.items.request.need_employees_with_segments == "true" &&
        this.items.request.set_services_ids &&
        this.items.request.set_services_ids != ''
      ) {
        let set_services_ids = this.items.request.set_services_ids.split(',');

        tempCompanyEmployee = company_employees.map((item) => {
          if (set_services_ids.some(id => item.set_segments_ids.includes(parseInt(id)))) {
              return item;
          }
        }).filter(item => item !== undefined);

        if (tempCompanyEmployee.length == 0) {
          return [{lead_fio: 'Нет подходящих контактов'}];
        }
      } else {
        if (company_employees.length == 0) {
          return [{lead_fio: 'Контакты отсутствуют'}];
        }

        tempCompanyEmployee = company_employees;
      }

      return tempCompanyEmployee.map((item) => {
        return {
          lead_fio: item.lead_fio,
          lead_segments: this.referencePropertyArrayGlueOutput(item.set_segments_ids),
          lead_phone: item.lead_phone,
          lead_company_phone: item.lead_company_phone,
          lead_email: item.lead_email
        };
      });
    },
    copyToClipboardInTable(value) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value).then(() => {
          this.showClipboardToast("Свойство скопировано в буфер обмена", "Удачно скопировано");
        }).catch(err => {
          console.error("Could not copy text: ", err);
          this.fallbackCopyTextToClipboard(value);
        });
      } else {
        this.fallbackCopyTextToClipboard(value);
      }
    },
    fallbackCopyTextToClipboard(value) {
      const textArea = document.createElement("textarea");
      textArea.value = value;
      // Avoid scrolling to bottom
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.width = "2em";
      textArea.style.height = "2em";
      textArea.style.padding = "0";
      textArea.style.border = "none";
      textArea.style.outline = "none";
      textArea.style.boxShadow = "none";
      textArea.style.background = "transparent";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand("copy");
        this.showClipboardToast("Свойство скопировано в буфер обмена", "Удачно скопировано");
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }
      
      document.body.removeChild(textArea);
    },
    showClipboardToast(message, title = 'Успех', variant = 'success') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true,
      });
    }    
  }
}



